/**
 * @generated SignedSource<<42f86f9cd4b910e3af9ab9768a13c42f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DalMobileNav_buttons$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"NavBarButtons_buttons">;
  readonly " $fragmentType": "DalMobileNav_buttons";
}>;
export type DalMobileNav_buttons$key = ReadonlyArray<{
  readonly " $data"?: DalMobileNav_buttons$data;
  readonly " $fragmentSpreads": FragmentRefs<"DalMobileNav_buttons">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DalMobileNav_buttons",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavBarButtons_buttons"
    }
  ],
  "type": "NavBarButton",
  "abstractKey": null
};

(node as any).hash = "e02bc8f3e86dfb3f1957dba1df01c445";

export default node;
